export enum BaseNetworkEnum {
  Testnet = 'base-sepolia',
  Mainnet = 'base',
}

export enum BaseAppchainStatusEnum {
  Running = 'running',
  Pending = 'pending',
  Staged = 'staged',
}

export enum BaseAppchainTypeEnum {
  SharedTestnet = 'shared-testnet',
  Testnet = 'testnet',
  Mainnet = 'mainnet',
}
